import styled from "@emotion/styled";

import defaultAvatarSvg from "@app-assets/svg/default-avatar.svg";

export const UserIcon = styled.div<{ avatarUrl: string }>`
    cursor: pointer;

    flex-shrink: 0;

    width: 40px;
    height: 40px;

    background: center 0 / contain no-repeat
        url(${({ avatarUrl }) => (avatarUrl.length > 0 ? avatarUrl : defaultAvatarSvg)}) #f7f8f9;
    border-radius: 50%;
`;
